var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isShown)?_c('span',{staticClass:"pm-chart-status",style:(`color:${_vm.statusInfo?.color};background:${_vm.statusInfo?.background};`)},[_vm._v(" "+_vm._s(_vm.statusInfo?.label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }